import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "isFixed"];
import * as React from 'react';
import cn from 'classnames';
import { Pane } from '../../pane';
var containerClass = {
  CONTAINER: 'container'
};
export var Container = function Container(props) {
  var children = props.children,
    className = props.className,
    isFixed = props.isFixed,
    paneProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(containerClass.CONTAINER, {
    '-fixed': isFixed
  }, className);
  return React.createElement(Pane, _extends({
    className: classNames,
    children: children
  }, paneProps));
};
Container.defaultProps = {
  isFixed: false
};
export default Container;